export const getRoomType = ({ hotelName, roomName }) => {
  if (process.env.VUE_APP_STAGING === '1') {
    if (hotelName === roomName) {
      return 'Standard Room'
    } else if (/deluxe/gi.exec(roomName)) {
      return 'deluxe'
    } else if (/superior/gi.exec(roomName)) {
      return 'superior'
    } else if (/executive/gi.exec(roomName)) {
      return 'executive'
    } else if (/suite/gi.exec(roomName)) {
      return 'suite'
    } else if (/interior/gi.exec(roomName)) {
      return 'interior'
    } else if (/premium/gi.exec(roomName)) {
      return 'premium'
    } else {
      return roomName
    }
  } else {
    return 'Standard Room'
  }
}

export const checkRoomAvailability = ({ dates, availability, rooms }) => {
  const AMOUNT_OF_DAYS = calculateDaysBetweenTwoDates(dates.start, dates.end)
  const startingIndex = findIndexInAvailability(dates.start, availability)
  const finishingIndex = startingIndex + AMOUNT_OF_DAYS

  for (let i = startingIndex; i <= finishingIndex; i++) {
    if (rooms > availability[i].value) {
      return false
    }
  }

  return true
}

const treatAsUTC = (date) => {
  const result = new Date(date)
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset())
  return result
}

const calculateDaysBetweenTwoDates = (startDate, endDate) => {
  const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / MILLISECONDS_PER_DAY
}

const findIndexInAvailability = (startDate, availability) => {
  let index
  availability.forEach((day, i) => {
    if (day.date === startDate) {
      index = i
    }
  })
  return index
}
